export default "__VITE_ASSET__DzxG7OAc__";